/*
 * Flaschenbauer Gratis-Aktion ab Warenwert (snippets/fb-gift-threshold.liquid)
 *
 * Gleicht nach jedem Warenkorb-Rerender (Event 'cart:updated' aus cart.js) den Ist-Zustand an
 * den Soll-Zustand an. Quelle ist ausschliesslich das serverseitig frisch gerenderte JSON
 * [data-fb-gt-state] (gleiches Muster wie fb-pfand.js). Das Theme rechnet keinen Preis, den
 * macht der automatische Rabatt.
 *
 * Soll:
 *   - Aktion aktiv (Server + Zeitfenster im Client), nicht abgelehnt, Basis >= Schwelle:
 *     genau EINE Gratis-Zeile (Property _fb_gift) mit Menge 1.
 *   - sonst: keine Gratis-Zeile.
 * Kunde entfernt die Gratis-Zeile: Warenkorb-Attribut _fb_gift_declined=true, danach kein
 * Auto-Add mehr. "Wieder hinzufuegen" loescht den Merker und legt das Set dazu.
 *
 * Schutz: entprellt (Pfand-Sync laeuft zuerst), busy/pending gegen Ueberholen, idempotent
 * (nur bei Abweichung ein Request), schlaegt ein Add fehl, kein zweiter Versuch auf dieser
 * Seite. Lieber kein Set als ein falsch berechnetes.
 */
(function () {
  'use strict';
  // Schutz gegen doppeltes Laden (Drawer + Warenkorbseite + PDP binden die Datei je einmal ein): sonst zwei Engines und zwei Click-Listener
  if (window.__fbGiftPromo) return;
  window.__fbGiftPromo = true;

  var busy = false, pending = false, timer = 0, addFailed = false, lastPct = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readState() {
    var els = document.querySelectorAll('[data-fb-gt-state]');
    if (!els.length) return null;
    try { return JSON.parse(els[els.length - 1].textContent); } catch (e) { return null; }
  }

  function inWindow(start, end) {
    var now = Date.now() / 1000;
    if (start > 0 && now < start) return false;
    if (end > 0 && now > end) return false;
    return true;
  }

  function isActive(st) { return !!(st && st.on && inWindow(st.start || 0, st.end || 0)); }

  function money(cents) {
    try {
      if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      }
    } catch (e) { /* Fallback unten */ }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function sectionsToRender() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
  }

  function publish(cart) {
    if (window.FoxTheme && FoxTheme.pubsub && cart && !cart.status) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
    }
  }

  // /cart/update.js liefert den ganzen Warenkorb samt Sections zurueck.
  function update(updates, attributes) {
    var body = { sections: sectionsToRender() };
    if (updates) body.updates = updates;
    if (attributes) body.attributes = attributes;
    return post('/cart/update.js', body).then(function (res) { if (res.ok) publish(res.d); return res.ok; });
  }

  // /cart/add.js liefert keinen Warenkorb: danach /cart.js holen und die Sections anhaengen.
  function addGift(vid) {
    // Frisch pruefen: ein parallel laufender Request (z. B. Pfand-Sync) kann den Drawer mit
    // einem aelteren Stand ersetzt haben. Liegt die Gratis-Zeile schon drin, nur neu rendern.
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var has = (cart.items || []).some(function (i) { return i.properties && i.properties._fb_gift; });
        if (has) {
          // Nur neu rendern, und zwar ALLE registrierten Sections (Drawer UND main-cart).
          // cart:refresh lieferte nur den Drawer, auf /cart wurde der Warenkorb dann leer gerendert.
          return rerender(cart);
        }
        return doAdd(vid);
      });
  }

  function rerender(cart) {
    var ids = sectionsToRender();
    if (!ids.length) { publish(cart); return true; }
    // Bewusst OHNE Accept-Header (Fallstrick Section Rendering, siehe fb-added-sheet.js)
    return fetch('/?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (sections) { cart.sections = sections; publish(cart); return true; });
  }

  function doAdd(vid) {
    return post('/cart/add.js', {
      items: [{ id: vid, quantity: 1, properties: { _fb_gift: '1' } }],
      sections: sectionsToRender()
    }).then(function (res) {
      if (!res.ok) { addFailed = true; showAddFailed(); return false; }
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { cart.sections = res.d.sections; publish(cart); return true; });
    });
  }

  function showAddFailed() {
    var d = document.querySelector('[data-fb-gt-drawer]');
    if (d) {
      var t = d.querySelector('[data-fb-gt-text]');
      if (t && d.getAttribute('data-fb-gt-fail')) t.textContent = d.getAttribute('data-fb-gt-fail');
      d.className = d.className.replace(/fb-gt-drawer--\w+/, 'fb-gt-drawer--declined');
    }
    updatePdp();
  }

  function run(task) {
    if (busy) { pending = true; return; }
    busy = true;
    Promise.resolve()
      .then(task)
      .catch(function () { /* naechster Cart-Event gleicht erneut ab */ })
      .then(function () { busy = false; if (pending) { pending = false; schedule(); } });
  }

  function reconcile() {
    decorate();
    var st = readState();
    if (!st) return;
    var lines = st.lines || [];
    var active = isActive(st);
    var want = active && !st.declined && st.base >= st.thr && st.vid > 0;
    var updates = {}, n = 0, i;

    if (want) {
      if (!lines.length) {
        if (addFailed) return;
        run(function () { return addGift(st.vid); });
        return;
      }
      if (lines[0].q !== 1) { updates[lines[0].k] = 1; n++; }
      // Rabatt greift nicht (Admin-Regel rechnet anders, Rabatt fehlt): Set nicht berechnen lassen.
      else if (lines[0].p > 0) { updates[lines[0].k] = 0; n++; addFailed = true; showAddFailed(); }
      for (i = 1; i < lines.length; i++) { updates[lines[i].k] = 0; n++; }
    } else {
      for (i = 0; i < lines.length; i++) { updates[lines[i].k] = 0; n++; }
    }
    if (n) run(function () { return update(updates); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 200);
  }

  // ---- Darstellung: Gratis-Zeile sperren, Drawer-Balken animieren, PDP-Zeile ----
  function lockRows() {
    var markers = document.querySelectorAll('[data-fb-gift-line]');
    for (var i = 0; i < markers.length; i++) {
      var row = markers[i].closest('.cart-item') || markers[i].closest('tr');
      if (!row) continue;
      row.classList.add('fb-gt-locked');
      var inps = row.querySelectorAll('.quantity__input');
      for (var k = 0; k < inps.length; k++) { inps[k].readOnly = true; inps[k].setAttribute('tabindex', '-1'); }
    }
  }

  function animateBar() {
    var bar = document.querySelector('[data-fb-gt-drawer] [data-fb-gt-pct]');
    if (!bar) { lastPct = null; return; }
    var pct = parseInt(bar.getAttribute('data-fb-gt-pct'), 10) || 0;
    if (!reduceMotion && lastPct !== null && lastPct !== pct) {
      bar.style.setProperty('--percent', lastPct + '%');
      void bar.offsetWidth;
      requestAnimationFrame(function () { bar.style.setProperty('--percent', pct + '%'); });
    }
    lastPct = pct;
  }

  function selCents(box) {
    // Box ist ein eigener Block neben dem Konfigurator: in derselben Produkt-Section suchen.
    // Ohne Konfigurator (oder bevor er gerendert hat) gilt der serverseitige Wert data-fb-gt-sel,
    // damit Liquid und JS gleich rechnen (kein Textsprung nach dem Laden).
    var scope = box.closest('.shopify-section') || box.closest('product-info') || document;
    var root = box.closest('[data-fb-configurator]') || scope.querySelector('[data-fb-configurator]');
    var v = root ? root.getAttribute('data-fb-sel-cents') : null;
    if (v === null || v === '') v = box.getAttribute('data-fb-gt-sel');
    return parseInt(v || '0', 10) || 0;
  }


  function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Aktionsbox auf der PDP (Designer + CRO 18.10.): Kopfzeile + Unterzeile, Restbetrag inkl. Auswahl.
  function updatePdp() {
    var boxes = document.querySelectorAll('[data-fb-gt-line]');
    if (!boxes.length) return;
    var st = readState();
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var start = parseInt(box.getAttribute('data-fb-gt-start') || '0', 10);
      var end = parseInt(box.getAttribute('data-fb-gt-end') || '0', 10);
      if (!inWindow(start, end) || (st && !st.on)) { box.hidden = true; continue; }
      if (box.hasAttribute('data-fb-gt-self')) continue;
      var thr = st ? st.thr : parseInt(box.getAttribute('data-fb-gt-thr'), 10);
      var base = st ? st.base : parseInt(box.getAttribute('data-fb-gt-base'), 10);
      var qty = st ? st.qty : 0;
      var declined = st ? st.declined : false;
      var sum = base + selCents(box);
      var name = esc(box.getAttribute('data-fb-gt-name'));
      var thrL = esc(box.getAttribute('data-fb-gt-thr-label'));
      // Ohne Wertangabe (18.10.): 2,49 EUR neben 69 EUR wirkt klein, der Wert steht im Warenkorb als Streichpreis.
      var offerHead = '<b class="fb-gt-g">Gratis dazu:</b> ' + name;
      var state, head, sub;
      if (qty > 0) {
        state = 'done'; head = '<b class="fb-gt-g">Dein gratis</b> ' + name + ' ist dabei';
        sub = 'Liegt schon im Warenkorb.';
      } else if (base >= thr && (declined || addFailed)) {
        state = 'declined'; head = offerHead;
        sub = 'Du hast es entfernt. <button type="button" class="fb-gt-readd" data-fb-gt-readd>Wieder hinzufügen</button>';
      } else if (sum >= thr) {
        state = 'sel'; head = offerHead;
        sub = base >= thr ? 'Kommt automatisch in deinen Warenkorb.' : 'Mit dieser Auswahl ist es dabei. Kommt automatisch in den Warenkorb.';
      } else {
        state = 'offer'; head = offerHead;
        sub = 'Ab ' + thrL + ' Warenwert, solange Vorrat. Mit dieser Auswahl fehlen noch <b class="fb-gt-amt num">' + money(thr - sum) + '</b>.';
      }
      var cls = 'fb-gt-line fb-gt-line--' + state;
      if (box.className !== cls) box.className = cls;
      var h = box.querySelector('[data-fb-gt-head]'), t = box.querySelector('[data-fb-gt-text]');
      if (h && h.innerHTML !== head) h.innerHTML = head;
      if (t && t.innerHTML !== sub) t.innerHTML = sub;
    }
  }

  function decorate() {
    lockRows();
    animateBar();
    updatePdp();
  }

  // ---- Kundenaktionen ----
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var readd = t.closest('[data-fb-gt-readd]');
    if (readd) {
      e.preventDefault();
      var st = readState();
      if (!st || !isActive(st) || !st.vid) return;
      readd.disabled = true;
      addFailed = false;
      run(function () {
        return post('/cart/update.js', { attributes: { _fb_gift_declined: '' } })
          .then(function () { return addGift(st.vid); });
      });
      return;
    }

    var rm = t.closest('.btn-remove, [is="cart-remove-item"]');
    if (!rm) return;
    var row = rm.closest('.cart-item') || rm.closest('tr');
    var marker = row && row.querySelector('[data-fb-gift-line]');
    if (!marker) return;
    // Gratis-Zeile: Entfernen + Merker in EINEM Request, Theme-Handler nicht ausfuehren.
    e.preventDefault();
    e.stopImmediatePropagation();
    rm.classList.add('btn--loading');
    var key = marker.getAttribute('data-key');
    var upd = {}; upd[key] = 0;
    run(function () { return update(upd, { _fb_gift_declined: 'true' }); });
  }, true);

  document.addEventListener('cart:updated', schedule);
  // Auswahl im Konfigurator (Menge, Verschluss, Zubehoer) -> PDP-Zeile neu bewerten.
  document.addEventListener('fb:selection', updatePdp);

  function init() {
    decorate();
    // Warenkorb schon beim Seitenaufruf ueber der Schwelle: einmal abgleichen.
    if ('requestIdleCallback' in window) requestIdleCallback(reconcile, { timeout: 1500 });
    else setTimeout(reconcile, 600);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Zeitfenster laeuft im offenen Tab ab: Zeile ausblenden, Gratis-Zeile entfernen.
  setInterval(function () { updatePdp(); reconcile(); }, 60000);
})();
